import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import InvalidEmployeeList from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/InvalidEmployeeList';
import ActionsContainer from 'screens/admin/Reviews/ReviewProcess/ReviewCycle/actionsContainer';
import styled from 'styled-components';
import { StyledBox, StyledGrid, StyledPaper, StyledTypography } from 'styles/common';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import theme from 'constants/theme';

import { getSurveyValidation } from 'services/engagement';
import { showErrorSnackbar } from 'services/snackbar';

import { DeerFooterContainer } from './DeerFooterContainer';

const Validation = ({ formId, backFn, nextFn }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [openedIndex, setOpenedIndex] = useState(null);

  const getData = () => {
    setLoading(true);
    getSurveyValidation({ surveyId: formId })
      .then((res) => {
        setData(res);
      })
      .catch((err) => {
        dispatch(showErrorSnackbar('Sorry, unable to do the data check!'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const save = () => {
    nextFn();
  };

  const handleCollapse = (index) => {
    if (openedIndex === index) {
      setOpenedIndex(null);
    } else {
      setOpenedIndex(index);
    }
  };

  return (
    <StyledBox bottomGutter={6}>
      <StyledTypography variant="h5" customColor={theme.palette.text.heading} bottomGutter={1}>
        Validation
      </StyledTypography>
      <StyledTypography variant="body" customColor={theme.palette.text.label}>
        Participants are selected based on Org chart. Check your
        <br />
        employee information is up to date{' '}
      </StyledTypography>

      {data &&
        data.map((res, index) => (
          <StyledPaper key={index} topGutter={1} bottomGutter={1} padding="1rem" id={index}>
            <Grid container>
              <Grid item sm={8}>
                <Grid container direction="column">
                  <StyledGrid item leftGutter={1} xs={12}>
                    <StyledTypography weight={600} color="textPrimary">
                      {res.sectionName}
                    </StyledTypography>
                  </StyledGrid>
                  <StyledGrid item leftGutter={1} xs={12}>
                    <StyledTypography color="textSecondary">{res.sectionDescription}</StyledTypography>
                  </StyledGrid>
                </Grid>
              </Grid>
              <Grid item sm={4}>
                <Grid container alignItems="flex-end" direction="column">
                  <Grid>
                    <StyledTypography1 color="textSecondary">{res.message}</StyledTypography1>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {res.employees && res.employees.length > 0 && (
              <InvalidEmployeeList res={res} openedIndex={openedIndex} handleCollapse={handleCollapse} index={index} />
            )}
          </StyledPaper>
        ))}

      <ActionsContainer
        ContainerComp={checkNewNavEnabled() ? DeerFooterContainer : null}
        loading={loading}
        onBackClick={backFn}
        onNextClick={nextFn && save}
        nextDisabled={false}
      />
    </StyledBox>
  );
};

const StyledTypography1 = styled(StyledTypography)`
  background: #fce8e8;
  color: #c24351;
  padding: 0.5rem 0.85rem;
  border-radius: 3px;
  float: right;
`;

export default Validation;
